import React from 'react';
import {maskName} from '../../../../utils/format';

export const PatientInfoSection: React.FC<{ data: any; maskPatientName?: boolean }> = ({ data, maskPatientName = false }) => (
  <>
    <section className="bg-white">
      <div className="inner-box">
        <h3 className="cont-tit"><span className="underline">어르신 정보</span></h3>
        <div className="round-box mt10">
          <div className="round-body">
            <ul className="detail-info col2">
              <li><span className="tit">환자이름</span><span className="txt">{maskPatientName ? maskName(data.patientName) : data.patientName}</span></li>
              <li><span className="tit">나이</span><span className="txt">{data.patientBirthYear}({data.patientAge}세)</span></li>
              <li><span className="tit">성별</span><span className="txt">{data.gender}</span></li>
              <li><span className="tit">체중(kg)</span><span className="txt">{data.weight}kg</span></li>
              <li><span className="tit">키(cm)</span><span className="txt">{data.height}cm</span></li>
              <li><span className="tit">관계</span><span className="txt">{data.relationshipName}</span></li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section className="bg-white">
      <div className="inner-box">
        <h3 className="cont-tit"><span className="underline">어르신 상태</span></h3>
        <div className="round-box mt10">
          <div className="round-body">
            {data.answers?.map((answer: any, index: number) => {
              let displayText = answer.answerText;
              try {
                const parsed = JSON.parse(answer.answerText);
                if (parsed.selection) {
                  displayText = parsed.text ? parsed.text : parsed.selection;
                }
              } catch {
                displayText = answer.answerText;
              }
              return (
                <div className="info-row" key={index} style={{alignItems: 'flex-start'}}>
                  <span className="label">{answer.questionName}</span>
                  <span className="cont" style={{wordBreak: 'break-all', flex: 1, minWidth: 0}}>{displayText}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  </>
);